import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { CiCirclePlus } from "react-icons/ci";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getMagiccodes } from "../actions/acc_actions";
import Button from "../components/Button";
import MagiccodeCard from "../components/MagiccodeCard";
import ContentLayout from "../components/layout/ContentLayout";
import Loading from "../utils/Loading";
import { formatDateWithSuffix } from "../utils/functions";

export default function Magiccode() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const accUrn = useSelector((state) => state.account.urn);

  const { isLoading, data } = useQuery({
    queryKey: ["magiccodes", accUrn],
    queryFn: () => getMagiccodes(accUrn),
    enabled: accUrn ? true : false,
  });

  if (isLoading) return <Loading />;

  console.log(data);

  return (
    <ContentLayout
      headerClassName={!(data?.data?.length > 0) ? "magic_code" : ""}
      header={
        <>
          <h1>
            {t("welcome_to")} <span>{t("magic_code")}</span>
          </h1>
          <p className="content_layout-subtitle">
            {t("magic_delivery_description")}
          </p>
          {!(data?.data?.length > 0) ? (
            <>
              <div className="magic_code-items">
                <div className="magic_code-item">
                  <img
                    src="/assets/images/icons/magic-code/create.png"
                    alt=""
                  />
                  <h4>
                    <span className="active">1 </span>
                    {t("create")}
                  </h4>
                  <p>{t("create_magiccode_description")}</p>
                </div>
                <div className="magic_code-item">
                  <img src="/assets/images/icons/magic-code/send.png" alt="" />
                  <h4>
                    <span className="active">2 </span>
                    {t("send")}
                  </h4>
                  <p>{t("send_magiccode_description")}</p>
                </div>
                <div className="magic_code-item">
                  <img src="/assets/images/icons/magic-code/claim.png" alt="" />
                  <h4>
                    <span className="active">3 </span>
                    {t("claim")}
                  </h4>
                  <p>{t("claim_magiccode_description")}</p>
                </div>
              </div>
              <Button
                onClick={() => navigate("add")}
                className="magic_code-btn"
              >
                {t("create_a_magic_code")}
              </Button>
            </>
          ) : (
            <div className="outlet-cards">
              <Link to="add" className="outlet-add btn">
                <CiCirclePlus size={48} />
                <h5>{t("add_new_magic_code")}</h5>
              </Link>

              {data?.data.map((item) => (
                <MagiccodeCard
                  key={item.data.created_at}
                  title={item.data.name}
                  secrets={item.data.secrets}
                  date={formatDateWithSuffix(item.created_at)}
                  expires={formatDateWithSuffix(item.data.expiry)}
                  effects={item.data.effects}
                  stats={item.stats}
                />
              ))}
            </div>
          )}
        </>
      }
    />
  );
}
